const defaultState = () => ({
  managementSchoolUuid: null
})

export const state = defaultState()

export const mutations = {
  RESET_STATE (state) {
    Object.assign(state, defaultState())
  },
  SET_MANAGEMENT_SCHOOL (state, { uuid }) {
    state.managementSchoolUuid = uuid
  }
}

export const actions = {
  async setManagementSchool ({ commit }, { uuid }) {
    commit('SET_MANAGEMENT_SCHOOL', { uuid })
  }
}
